var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{attrs:{"options":_vm.jobs,"props":_vm.prop},on:{"change":_vm.onJobsChanged},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }